<template>
  <v-sheet color="#FBF9F4">
    <component :is="component" class="py-10 py-md-13 py-lg-16">
      <TitleWidget v-if="title" class="text-center">{{ title }}</TitleWidget>

      <LoadingWidget v-if="loading" />

      <template v-else>
        <slot />
      </template>
    </component>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { VContainer } from "vuetify/lib/components";

export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    component() {
      return this.container ? "v-container" : "div";
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    VContainer,
  },
};
</script>
